import { EventBuilder } from './EventBuilder';
import { AdGameAreas } from './AdParamBuilder';

export interface IBotOptionParams {
    botSubscriptionChangeGameArea: any;
    botSubscriptionStatus: any; //
}

export class BotParamBuilder extends EventBuilder {
    constructor() {
        super();
    }

    public setAllAdParamsFromGame() {}

    public getParams<T>(isSubscribed: boolean): IBotOptionParams {
        return {
            botSubscriptionChangeGameArea: AdGameAreas.MAP,
            botSubscriptionStatus: isSubscribed ? 1 : 0,
        };
    }

    public setParams(keys: Map<string, unknown>): void {
        keys.forEach((value, key) => {});
    }
}
